module.exports = __webpack_public_path__ + "static/wix_3-de5cc46176aa1e61b28a02234192b48b.png";